import { Dispatch } from 'redux';
import { fetchLocations } from '../../../../services/discovery/fetchLocations';
import { makeFetchModule } from '../../../_utils';
import { storeSourceSets } from '../../entities';

const callbacks = {
    onSuccess: (dispatch: Dispatch, { entities }: { entities: object }) => {
        dispatch(storeSourceSets(entities));
    },
};
const { reducer, fetchData, reset } = makeFetchModule(
    'app/discovery/locationsFetching',
    fetchLocations,
    callbacks
);

export default reducer;
export { fetchData, reset };
